import { jsx as e, jsxs as i } from "react/jsx-runtime";
function r(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 20 20", width: "1em", ...l, children: /* @__PURE__ */ i("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("circle", { cx: 10, cy: 10, fill: "#00182E", r: 10 }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M10 0c5.522 0 10 4.477 10 10s-4.478 10-10 10C4.477 20 0 15.522 0 10S4.477 0 10 0zm0 4.474L4.488 6.82s.366 8.706 5.512 8.706c5.145 0 5.512-8.706 5.512-8.706L10 4.474zm2.603 3.44l.698.917-3.913 3.977-.002-.005-.005.005-2.182-2.432.91-.8 1.314.954 3.18-2.617z",
        fill: "#1ED560"
      }
    )
  ] }) });
}
export {
  r as default
};
